<script setup lang="ts">
import { WreathIcon } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <div>
    <Icon
      :path="WreathIcon"
      :size="32"
      class="gold-gradient-text"
      filled
      :bindings="{ fill: 'url(#gold_gradient)' }"
    >
      <linearGradient
        gradientTransform="rotate(11, 0.5, 0.5)"
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="gold_gradient"
      >
        <stop stop-color="#ffc018" stop-opacity="1" offset="0%"></stop>
        <stop stop-color="#d87700" stop-opacity="1" offset="100%"></stop>
      </linearGradient>
    </Icon>
  </div>
</template>
